/**
 * §I-2.5 · Explicit anon-session recovery helpers.
 *
 * After login, an owner may have anonymous analyses created earlier on
 * this browser. We NEVER link automatically: we first probe a neutral
 * boolean, then link only on the owner's explicit confirmation.
 */
import { api } from "@/lib/api";
import { LS_ANON } from "@/lib/vg2AnonAxios";

const LS_DISMISS = "vg2_anon_link_dismissed";

function anonHeaders() {
  const t = localStorage.getItem(LS_ANON);
  return t ? { "X-VG2-Anon-Token": t } : {};
}

/** Already dismissed the prompt for the current anon token? */
export function anonLinkDismissed() {
  const t = localStorage.getItem(LS_ANON);
  if (!t) return true;
  return localStorage.getItem(LS_DISMISS) === t;
}

/** Remember the refusal for THIS anon token so we don't re-prompt. */
export function dismissAnonLink() {
  const t = localStorage.getItem(LS_ANON);
  if (t) localStorage.setItem(LS_DISMISS, t);
}

/** Neutral probe — returns true when there is something linkable. */
export async function checkAnonLinkAvailable() {
  const t = localStorage.getItem(LS_ANON);
  if (!t) return false;
  try {
    const r = await api.get("/v2/owner/anon-link/available", { headers: anonHeaders() });
    return !!(r.data && r.data.available);
  } catch {
    return false;
  }
}

/**
 * Confirm the link. On success, drops the anon token (so the browser no
 * longer carries an orphaned session) and clears the dismiss marker.
 */
export async function confirmAnonLink() {
  const r = await api.post("/v2/owner/anon-link/confirm", null, { headers: anonHeaders() });
  localStorage.removeItem(LS_ANON);
  localStorage.removeItem(LS_DISMISS);
  return r.data;
}
